export default "images/导航 (2).png";